<template>
	<ul class="list-inline consumption-list position-relative">
		<li class="list-inline-item">
			<i class="mdi mdi-tag-outline"></i>
			{{ car.ad.internalNumber }}
		</li>
		<template v-if="car.ad.consumptionCombined">
			<li
				v-if="
					car.ad.consumptionUnit === 'KILOWATT_HOUR' ||
					car.ad.fuel === 'ELECTRICITY'
				"
				class="list-inline-item"
			>
				<i class="mdi mdi-lightning-bolt"></i>
				{{ car.ad.consumptionCombined }} kWh/100km (komb.)
				<sup>4</sup>
			</li>
			<li v-else class="list-inline-item">
				<i class="mdi mdi-gas-station"></i>
				{{ car.ad.consumptionCombined }} l/100km (komb.)
				<sup>4</sup>
			</li>
			<li class="list-inline-item">
				<i class="mdi mdi-earth"></i>
				{{ car.ad.co2 }}g CO₂/km (komb.)
			</li>
		</template>
	</ul>
</template>

<script>
export default {
	name: 'ListItemSubtext',
	props: {
		car: Object,
	},
}
</script>

<style scoped></style>
